
export default {
  name: 'App',
  components: {
  },
  mounted() {
    this.custom()
    this.changeLang()
  },
  data() {
    return {
      form: {
        name: "",
        phone: "",
        email: "",
        content: "",
      },
      language: localStorage.getItem("language")
    }
  },
  methods: {
    
    submitForm() {
      if (!this.form.content) {
        let message =
          this.language == "CN" ? "请填写内容" : "Please fill in the content";
        this.$emit("msg", message, false);
      } else if (!this.form.name) {
        let message =
          this.language == "CN" ? "请填写您的姓名" : "Please fill in your name";
        this.$emit("msg", message, false);
      } else if (!this.form.phone && !this.form.email) {
        let message =
          this.language == "CN"
            ? "请填写您的联系方式"
            : "Please fill in your contact information";
        this.$emit("msg", message, false);
      } else {

        $.ajax({
          type: "POST",
          url: "https://www.yoni-tech.com/api/leave-message/add",
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify(this.form)
        });
        this.form.name = "";
        this.form.phone = "";
        this.form.email = "";
        this.form.content = "";
        let message =
          this.language == "CN"
            ? "提交成功"
            : "Submit Success";
        this.$emit(
          "msg",
          message,
          true
        );
      }
    },
    gotoContact() {
      this.$router.push('/contactUs')
    },
    gotoAbout() {
      this.$router.push('/about')
    },
    goToPrice() {
      this.$router.push('/price')
    }
  }
}
  